"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const app_json_1 = require("./app.json");
const App_1 = __importDefault(require("./src/App"));
require("./web/main.css");
const react_redux_1 = require("react-redux");
const store_1 = require("./src/store/store");
const react_1 = __importDefault(require("react"));
const Root = () => (react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
    react_1.default.createElement(App_1.default, null)));
react_native_1.AppRegistry.registerComponent(app_json_1.name, () => Root);
react_native_1.AppRegistry.runApplication(app_json_1.name, {
    initialProps: {},
    rootTag: document.getElementById('app-root'),
});
